// Optional Rybbit analytics. The script is loaded in root.tsx only when
// VITE_RYBBIT_SITE_ID is set at build time; without it every call is a no-op.
// Typed wrappers so callers never use raw rybbit.track().

declare global {
  interface Window {
    rybbit?: {
      track: (event: string, props?: Record<string, string | number | boolean>) => void
    }
  }
}

function track(event: string, props?: Record<string, string | number | boolean>) {
  window.rybbit?.track(event, props)
}

export const analytics = {
  /** A call-to-action button was clicked. */
  ctaClick(label: string, href: string) {
    track('cta_click', { label, href })
  },
  /** The mobile menu was opened. */
  mobileMenuOpen() {
    track('mobile_menu_open')
  },
}
